import { CellContext } from "@tanstack/react-table";
import { WorkspaceDetails } from "@common/types/workspace";

export interface WorkspaceDetailsRow extends WorkspaceDetails {
    id: string;
}

export function NameCell({
    row,
}: Readonly<CellContext<WorkspaceDetailsRow, any>>) {
    return <span>{row.original.workspace.name}</span>;
}
